<template>
  <div class="">
    <div class="">
      <div class="">
        <b-container class="mt-5">
          <b-row>
            <b-col xl="12" class="ms-auto me-auto">
              <b-card>
                <b-row>
                  <b-col md="6">
                    <h4>User attributes</h4>
                    <table class="table table-striped">
                      <tr v-for="d in userAttributes" :key="`user-${d.key}`">
                        <td>{{ d.key }}</td>
                        <td>{{ d.value }}</td>
                      </tr>
                    </table>
                  </b-col>
                  <b-col md="6">
                    <h4>Custom attributes</h4>
                    <table class="table table-striped">
                      <tr
                        v-for="d in customAttributes"
                        :key="`custom-${d.key}`"
                      >
                        <td>{{ d.key }}</td>
                        <td>{{ d.value }}</td>
                      </tr>
                    </table>
                  </b-col>
                </b-row>

                <h4>JWT</h4>
                <pre
                  cols="64"
                  style="width: 640px; white-space: pre-wrap; overflow: auto"
                >
                {{ jwt }}
              </pre
                >

                <h4>Org Data</h4>
                <pre
                  cols="64"
                  style="width: 640px; white-space: pre-wrap; overflow: auto"
                >
                {{ orgData }}
              </pre
                >
              </b-card>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
// import Amplify from 'aws-amplify'

export default {
  name: 'WhoAmI',
  components: {},
  data() {
    return {}
  },
  mounted() {},
  computed: {
    loggedInUser() {
      return this.$store.getters.loggedInUser
    },
    jwt() {
      return this.loggedInUser.signInUserSession.idToken.jwtToken
    },
    payload() {
      return this.loggedInUser.signInUserSession.idToken.payload
    },
    organizationName() {
      return this.$store.getters.userInfo.organizationName
    },
    orgData() {
      return JSON.parse(window.localStorage.orgData)
    },
    payloadAttributes() {
      if (!this.loggedInUser) {
        return []
      }

      return Object.entries(this.payload).map(([key, value]) => ({
        key,
        value:
          value !== null && typeof value === 'object'
            ? JSON.stringify(value)
            : value
      }))
    },
    userAttributes() {
      return this.payloadAttributes.filter(
        ({ key }) => !key.startsWith('custom:')
      )
    },
    customAttributes() {
      return this.payloadAttributes.filter(({ key }) =>
        key.startsWith('custom:')
      )
    }
  }
}
</script>

<style lang="scss" scoped></style>
